var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Label",class:_vm.CssClass,attrs:{"DataType":_vm.m_Attribute.DataType},domProps:{"innerHTML":_vm._s(_vm.NewLabelText)}})}
var staticRenderFns = []

export { render, staticRenderFns }